
import React from "react";
import PageHeader from "../../components/PageHeader";
import TeamMemberUpdateComponent from "../../components/TeamMembers/TeamMemberUpdate";

class TeamMemberUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Team Member Update"
                            Breadcrumb={[
                                { name: "Team Members", navigate: "/team-members" },
                                { name: "Team Member Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <TeamMemberUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamMemberUpdate;
